import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

// function getOfficeName (officeId) {
//   return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(hospital => hospital.value === officeId)[0].text
// }
const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, caseHistoryDetails, vm) => {
  try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      // report headings
      const reportHeadcaseHistoryDetailsReport = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tablebillingReport',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadcaseHistoryDetailsReport.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadcaseHistoryDetailsReport.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadcaseHistoryDetailsReport.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadcaseHistoryDetailsReport.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadcaseHistoryDetailsReport.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      pdfContent.push(
        {
          table: {
            style: 'tablebillingReport',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { text: '', style: 'top' }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      // -------------- Report Body ----------
      // ------------------------------------------------------------------------------------
      // personal information start
      pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.personal_info'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const personalRowsHead = [
          [
            { text: vm.$t('social_service.ofc_name') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getOfficeName(caseHistoryDetails.office_id), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.case_history_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.case_history_no, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.pat_type') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getPatientType(caseHistoryDetails.patient_type), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.register_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.hos_reg_no, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.patient_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.patient_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.father_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.father_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.father_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.mother_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.mother_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.mother_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.mother_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.id_type') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getIdentityType(caseHistoryDetails.id_type), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.nid_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.id_no, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.form_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.form_no, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.patient_guar_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.guardian_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.patient_guar_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.guardian_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.relation_patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.relation, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.relation_patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.relation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.age') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.age, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.occupation_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.occupation, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.occupation_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.occupation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.monthly_income') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.$n(caseHistoryDetails.patient_reg_mains.monthly_income), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.mat_status') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getMeritalStatus(caseHistoryDetails.marital_status), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.edu_quali_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.qualification, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.edu_quali_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.qualification_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.religion_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.religion, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.religion_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.religion_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.nationality_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.nationality, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.nationality_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.nationality, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '18%', '15%', '18%', '15%', '19%'],
            body: personalRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
        // personal information end -----------------
        const pageBreakRowsHead = [
          [
            { text: '', style: 'th', alignment: 'left', bold: true, pageBreak: 'after' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['100%'],
            body: pageBreakRowsHead
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        // present address start
      pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('educational_management.present_business_address'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const presentAddressRowsHead = [
          [
            { text: vm.$t('globalTrans.division') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDivisionName(caseHistoryDetails.pre_division_id), style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.upazila') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getUpazillaName(caseHistoryDetails.pre_upazilla_id), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.district') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDistrictName(caseHistoryDetails.pre_division_id), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.house_road_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.present_address, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.house_road_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.present_address_bn, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: presentAddressRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
        // present address end -------------
        // Empty Space
        pdfContent.push(
          { text: '', style: 'empty_space' }
        )
        // permanent address start
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('educational_management.permanent_address'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const permanentAddressRowsHead = [
          [
            { text: vm.$t('globalTrans.division') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDivisionName(caseHistoryDetails.division_id), style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.upazila') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getUpazillaName(caseHistoryDetails.upazilla_id), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.district') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDistrictName(caseHistoryDetails.district_id), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.house_road_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.permanent_address, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.house_road_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.permanent_address_bn, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: permanentAddressRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
        // permanent address end -------------
        // family information start
        // Empty Space
        pdfContent.push(
          { text: '', style: 'empty_space' }
        )
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.patient_family_info'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
          const familyRowsHead = [
            [
              { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.fam_mem_en'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.age'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.gender'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.occupation_en'), style: 'th', alignment: 'center' }
            ]
          ]

          if (vm.$i18n.locale === 'bn') {
            caseHistoryDetails.casehistory_family_members.map((report, index) => {
              familyRowsHead.push(
              [
                { stack: [[(index + 1)]], style: 'td', alignment: 'center' },
                // { stack: [[report.patient_name_bn, report.age ? report.age : '-', report.gender_name_bn]], style: 'td', alignment: 'center' },
                // { stack: [[report.hos_ward_id ? (report.hos_ward_id) : '-', report.hos_bed_id ? (report.hos_bed_id) : '-', report.hos_reg_no ? (report.hos_reg_no) : '-']], style: 'td', alignment: 'center' },
                // { stack: [[report.address_bn, report.phone_no]], style: 'td', alignment: 'center' },

                { text: report.member_name_bn, style: 'td', alignment: 'center' },
                { text: report.age, style: 'td', alignment: 'center' },
                { text: vm.getGender(report.gender), style: 'td', alignment: 'center' },
                { text: report.occupation_bn, style: 'td', alignment: 'center' }
              ])
            })
          } else if (vm.$i18n.locale === 'en') {
            caseHistoryDetails.casehistory_family_members.map((report, index) => {
              familyRowsHead.push(
              [
                { stack: [[(index + 1), report.delivery_date]], style: 'td', alignment: 'center' },
                // { stack: [[report.patient_name, report.age ? report.age : '-', report.gender_name_en]], style: 'td', alignment: 'center' },
                // { stack: [[report.hos_ward_id ? (report.hos_ward_id) : '-', report.hos_bed_id ? (report.hos_bed_id) : '-', report.hos_reg_no ? (report.hos_reg_no) : '-']], style: 'td', alignment: 'center' },
                // { stack: [[report.address, report.phone_no]], style: 'td', alignment: 'center' },

                { text: report.member_name_bn, style: 'td', alignment: 'center' },
                { text: report.age, style: 'td', alignment: 'center' },
                { text: vm.getGender(report.gender), style: 'td', alignment: 'center' },
                { text: report.occupation_bn, style: 'td', alignment: 'center' }
              ])
            })
          }

      pdfContent.push({
        table: {
          headerRows: 1,
          widths: ['10%', '40%', '10%', '10%', '30%'],
          body: familyRowsHead
        }
      })
        // family information end -------------
        pdfContent.push(
          { text: '', style: 'empty_space' }
        )
        // Admission and others start
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.admiss'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const admissionRowsHead = [
          [
            { text: vm.$t('social_service.register_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.hos_reg_no, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.hos_dept') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDepartmentName(caseHistoryDetails.patient_reg_mains.department_id), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.ward_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getWardName(caseHistoryDetails.patient_reg_mains.hos_ward_id), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.bed_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.hos_bed_id, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.dises_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.patient_situation, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.dises_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.patient_reg_mains.patient_situation_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.wight') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.weight, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.blood_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.blood_group, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.blood_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.blood_group_bn, style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '18%', '15%', '18%', '15%', '19%'],
            body: admissionRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
        // Documents
        pdfContent.push(
          { text: '', style: 'empty_space', pageBreak: 'before' }
        )
        const othersRowsHead = [
          [
            { text: vm.$t('social_service.regular_checkup_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.regular), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.regular_comment_bn : caseHistoryDetails.casehistory_others.regular_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_others.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.vaccination') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.vaccination), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.vaccination_comment_bn : caseHistoryDetails.casehistory_others.vaccination_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.food_all') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.food), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.food_comment_bn : caseHistoryDetails.casehistory_others.food_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_others.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.smoking') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.smoking), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.smoking_comment_bn : caseHistoryDetails.casehistory_others.smoking_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.phy_dis') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.physical), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.physical_comment_bn : caseHistoryDetails.casehistory_others.physical_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_others.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.tak_med_adv') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.medicine), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.medicine_comment_bn : caseHistoryDetails.casehistory_others.medicine_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.other_dises') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.other_disease), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.other_disease_comment_bn : caseHistoryDetails.casehistory_others.other_disease_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_others.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.familly_his_dis') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_others.family_history), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_others.family_history_comment_bn : caseHistoryDetails.casehistory_others.family_history_comment)]], style: 'td', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: othersRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })

        // Admission and others end -------------

        pdfContent.push(
          { text: '', style: 'empty_space' }
        )
        // Admission and others start
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.pat_social'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        // Medications
        const medsRowsHead = [
          [
            { text: vm.$t('social_service.personal_home') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.personal), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.personal_comment_bn : caseHistoryDetails.casehistory_socio.personal_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_socio.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.affec_geo_posi') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.affected), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.affected_comment_bn : caseHistoryDetails.casehistory_socio.affected_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.jakat_eli') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.jakat), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.jakat_comment_bn : caseHistoryDetails.casehistory_socio.jakat_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_socio.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.vill_cen_life') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.village_centric), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.village_centric_comment_bn : caseHistoryDetails.casehistory_socio.village_centric_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.city_center_life') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.city_centric), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.city_centric_comment_bn : caseHistoryDetails.casehistory_socio.city_centric_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_socio.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.prv_serv_from_hos') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.prev_hos), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.prev_hos_comment_bn : caseHistoryDetails.casehistory_socio.prev_hos_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.prv_serv_other_hos') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.prev_other_hos), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.prev_other_hos_comment_bn : caseHistoryDetails.casehistory_socio.prev_other_hos_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_socio.regular), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.regu_serv_take_dss') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.reg_dss), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.reg_dss_comment_bn : caseHistoryDetails.casehistory_socio.reg_dss_comment)]], style: 'td', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.pat_eli_fin_help') + ': ', style: 'th', alignment: 'left', bold: true },
            { stack: [[vm.getAnswer(caseHistoryDetails.casehistory_socio.pat_eligibility), vm.$t('social_service.comment') + ': ' + (vm.$i18n.locale === 'bn' ? caseHistoryDetails.casehistory_socio.pat_eligibility_comment_bn : caseHistoryDetails.casehistory_socio.pat_eligibility_comment)]], style: 'td', alignment: 'left' },
            // { text: vm.getAnswer(caseHistoryDetails.casehistory_socio.regular), style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left', bold: true }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: medsRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
        // Social information
        pdfContent.push(
          { text: '', style: 'empty_space', pageBreak: 'before' }
        )
        const socioRowsHead = [
          [
            { text: vm.$t('social_service.medi_assis_ofc') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getMedAssistace(caseHistoryDetails.casehistory_med_assistance.assistance_type_id), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.rehabil_desc_par_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.rehab_description, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.rehabil_desc_par_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.rehab_description_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.cash_recv_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.receiver_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.cash_recv_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.receiver_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.case_rec_des_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.designation, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.case_rec_des_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.designation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.related_officer_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.officer_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.related_officer_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.officer_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.related_officer_comment_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.comments, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.related_officer_comment_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: caseHistoryDetails.casehistory_med_assistance.comments_bn, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '18%', '15%', '18%', '15%', '19%'],
            body: socioRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })

        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
          info: {
            title: reportTitle
            // use this to change title
            // author: 'john doe',
            // subject: 'subject of document',
            // keywords: 'keywords for document'
            },
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'landscape',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          top: {
            margin: [0, 30, 0, 0]
          },
          top2: {
            margin: [0, 50, 0, 0]
          },
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th1: {
              fontSize: 9
            },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
          },
          pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
            return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
         }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print() // use this to change filename ddr
        // pdfMake.createPdf(docDefinition, null, null, null).print() // )
    } catch (error) {
      if (error) {
      }
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
